import React from 'react';
import { GoBug } from 'react-icons/go';

export function BugIcon({
  color = '#e44d42',
  size = 20,
}: {
  color?: string;
  size?: number;
}) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,
  // @typescript-eslint/no-unsafe-assignment
  const Icon = GoBug as React.ComponentType<{ color?: string; size?: number }>;
  return <Icon color={color} size={size} />;
}
